import { createFileRoute } from '@tanstack/react-router'

import { PaymentStep } from '@/pages/create-booking-page'

export const Route = createFileRoute('/_dashboard/branch/$branchId/create/_wizard/payment')({
    component: PaymentStep,
})
